"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var lodash_1 = require("lodash");
var usePrevious = function (state, callback) {
    var ref = react_1.useRef();
    react_1.useEffect(function () {
        if (!lodash_1.isEqual(ref.current, state)) {
            ref.current = state;
            if (callback) {
                callback(state);
            }
        }
    });
};
exports.default = usePrevious;
